<template>
	<section id="create-curadoria">
		<form @submit.prevent="saveCuradoria">
			<container textButton="voltar" :pathName="path" :pathIcone="true">
				<div class="errors">
					<div v-if="submitted && $v.form.nome.$error" class="invalid-feedback">
						<p v-if="!$v.form.nome.required">O nome da Curadoria é obrigatória</p>
					</div>
				</div>
				<div class="form-controls">
					<div :class="[submitted && $v.form.nome.$error && 'is-invalid', 'field name']">
						<label for="name">Digite o nome:</label><input type="text" name="name" id="name" v-model.lazy="form.nome" autocomplete="off" />
					</div>
					<div class="field">
						<check-status :checked="form.flagAtivo" @change="checkStatusChange" @click="alert('Funciona')"></check-status>
					</div>
				</div>
				<div class="controls">
					<multiselect v-model="form.perfil" :options="perfis" :close-on-select="true" :clear-on-select="true" :searchable="false" placeholder="Selecione a sub-curadoria"
						:showNoResults="true" selectedLabel="Selecionado" selectLabel="Click para selecionar" deselectLabel="Click para remover" label="nome" track-by="nome">
				</multiselect>
				</div>
			</container>

			<div class="submit-form">
				<button-submit class="large" type="submit" :disabled="loadingSubmit">
					<load-submit v-if="loadingSubmit"></load-submit>
					<span v-else>SALVAR</span>
				</button-submit>
			</div>
		</form>
	</section>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import LoadSubmit from '@/components/shared/LoadSubmit'
import { curadoria } from '@/services/curadoria'
import Container from '@/components/shared/Container'
import ButtonSubmit from '@/components/shared/ButtonAction'
import CheckStatus from '@/components/shared/Status'

export default {
	name: 'createCuradoria',
	components: { Container, ButtonSubmit, CheckStatus, LoadSubmit },
	data () {
		return {
			form: {
				nome: '',
				flagAtivo: true
			},

			path: '',
			submitted: false,
			loadingSubmit: false
		}
	},
	validations: {
		form: {
			nome: {
				required
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.path = from.path
		})
	},
	async created () {
		if (this.$route.params.id) {
			const objCuradoria = await curadoria.findById(this.$route.params.id)

			if (objCuradoria.status === 200) {
				this.loadingSubmit = false
				const { nome, flagAtivo } = objCuradoria.data
				this.form = { nome, flagAtivo }
			} else {
				// redirect to 404 page
				this.loadingSubmit = false
				return this.$router.push({ name: 'curadoriaList' })
			}
		}
	},
	methods: {
		async saveCuradoria () {
			this.submitted = true
			this.loadingSubmit = true

			this.$v.$touch()
			if (this.$v.$invalid) {
				this.loadingSubmit = false
				return
			}

			this.form = {
				...this.form,
				flagAtivo: this.form.flagAtivo ? 1 : 0
			}
			if (this.form.flagAtivo) this.form.flagAtivo = 1
			else this.form.flagAtivo = 0

			if (this.$route.params.id) {
				const objCuradoria = await curadoria.update(this.$route.params.id, this.form)
				this.loadingSubmit = false

				if (objCuradoria.status === 200) {
					this.loadingSubmit = false
					return this.$router.push({ name: 'curadoriaList' })
				} else {
					this.loadingSubmit = false
					return console.log(objCuradoria)
				}
			}

			const objCuradoria = await curadoria.create(this.form)

			if (objCuradoria.status === 200) {
				this.loadingSubmit = false
				return this.$router.push({ name: 'curadoriaList' })
			} else {
				this.loadingSubmit = false
				return console.log(objCuradoria)
			}
		},
		checkStatusChange () {
			this.form.flagAtivo = !this.form.flagAtivo
			return this.form.flagAtivo
		}
	}
}
</script>

<style lang="scss" scoped>
	#create-curadoria {
		.form-controls {
			display: grid;
			grid-template-columns: auto 170px;
			grid-gap: 0 16px;
			margin-top: 46px;

			.field {
				background-color: #f3f7fc;
				border-radius: 5px;
				color: #4f5c6b;
				height: 50px;
				display: flex;
				align-items: center;
				padding: 8px 11px;

				&.name {
					display: grid;
					grid-template-columns: 120px auto;
					grid-gap: 0 0;
				}

				input[type=text] {
					border: none;
					outline: none;
					width: auto;
					height: 100%;
					font-size: 1em;
					padding-left: 8px;
					background-color: rbga(255, 255, 255, 0.2);
				}

				label {
					font-weight: $font-weight-default-bolder;
				}
			}
		}
		.controls {
			display: grid;
			grid-template-columns: auto 170px;
			grid-gap: 0 16px;
			margin-top: 46px;
			.field {
				background-color: #f3f7fc;
				border-radius: 5px;
				color: #4f5c6b;
				height: 50px;
				display: flex;
				align-items: center;
				padding: 8px 11px;
				input[type=text] {
					border: none;
					outline: none;
					height: 100%;
					font-size: 1em;
					padding-left: 8px;
					background-color: rbga(255, 255, 255, 0.2);
				}
			}
		}

		.submit {
			display: flex;
			justify-content: center;
			margin-top: 30px;
		}
	}
.is-invalid {
	border: 1px solid tomato;
}
</style>
